// tslint:disable:max-line-length

import React from 'react';

export const EditorCrop = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M2,0v2H0v2h2v10h10v2h2v-2h2v-2h-2V3l2-2l-1-1l-2,2H4V0H2z M4,4h7l-7,7V4z M12,5v7H5L12,5z" />
    </svg>
  );
};
